import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const VerificationSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to download page after 3 seconds
    const timer = setTimeout(() => {
      navigate('/download');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className='verification-container'>
      <div className='verification-content'>
        <div className='verification-card'>
          <div className='verification-icon'>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="#177508"/>
              <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h1 className='titles large color black'>Email Verified Successfully!</h1>
          
          <p className='paragraphs medium color charcoal'>
            Your email has been confirmed. You will be redirected to the download page shortly.
          </p>
          
          <div className='verification-actions'>
            <button 
              className='btn primary'
              onClick={() => navigate('/download')}
            >
              Go to Download Page
            </button>
            <button 
              className='btn secondary'
              onClick={() => navigate('/')}
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default VerificationSuccess; 